// src/config/config.js
/* Helpers */
const toAbs = (urlLike) => {
  try {
    return new URL(urlLike, window?.location?.origin).toString();
  } catch {
    return urlLike;
  }
};

const apiEnv = process.env.REACT_APP_API_URL || '/api';
const API_ABS = toAbs(apiEnv);

// Si REACT_APP_WS_URL non fourni, on déduit depuis l’API (https -> wss)
const wsEnv = process.env.REACT_APP_WS_URL;
const wsFromApi = (() => {
  try {
    const u = new URL(API_ABS);
    const proto = u.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${u.host}`;
  } catch {
    const proto = window?.location?.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window?.location?.host}`;
  }
})();
const WS_BASE = toAbs(wsEnv || wsFromApi);

// Base & path pour socket.io (surchargeables par env)
const SOCKET_BASE_ENV = (process.env.REACT_APP_SOCKET_BASE || '').trim();
const SOCKET_BASE = SOCKET_BASE_ENV || WS_BASE;
const SOCKET_PATH = process.env.REACT_APP_SOCKET_PATH || '/socket.io';

export const CONFIG = {
  // API (toujours absolu)
  API_URL: API_ABS,

  // Compat : champs historiques
  WS_URL: wsEnv, // si défini côté env
  WEBSOCKET_URL: WS_BASE, // base websocket déduite (wss/ws + host)

  // socket.io
  SOCKET_BASE,
  SOCKET_PATH,

  // divers
  APP_VERSION: process.env.REACT_APP_BUILD_TIME || process.env.REACT_APP_VERSION || 'dev',
  SPRITE_URL: '/icons/icones-musiq.svg',
  DEBUG: String(process.env.REACT_APP_DEBUG ?? 'true').toLowerCase() === 'true',

  // SOS / 3CX
  SOS_NUMBER: process.env.REACT_APP_SOS_NUMBER || '',
  SOS_3CX_URL: process.env.REACT_APP_SOS_3CX_URL || '',
};

export const ICONS = {
  arrivee: require('../assets/arrivee.svg'),
  exit: require('../assets/exit.svg'),
  logo1: require('../assets/logo1.svg'),
  logo2: require('../assets/logo2.svg'),
  plus: require('../assets/plus.svg'),
  salles: require('../assets/salles.svg'),
  sortie: require('../assets/sortie.svg'),
};
